<template>
  <div class="project-finance-summary">
    <v-row>
      <v-col cols="12" lg="2">
        <div class="project-finance-summary__card">
          <div class="project-finance-summary__card-title">Last month</div>
          <div class="project-finance-summary__card-data">
            <div class="project-finance-summary__value">
              {{ summaryData.current_month }}
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" lg="2">
        <div class="project-finance-summary__card">
          <div class="project-finance-summary__card-title">Project Members</div>
          <div class="project-finance-summary__card-data">
            <div class="project-finance-summary__value">
              {{ summaryData.summary.contracts_size ? summaryData.summary.contracts_size : 0 }}
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" lg="">
        <div class="project-finance-summary__card">
          <div class="project-finance-summary__card-title">Total worked</div>
          <div class="project-finance-summary__card-data">
            <div class="project-finance-summary__value">
              {{ summaryData.summary.time ? summaryData.summary.time : '00:00:00' }}
            </div>
            <div v-if="summaryData.summary.time_change"
              class="project-finance-summary__trend"
              :class="{ 'project-finance-summary__trend--decrease':
                summaryData.summary.time_change < 0 }"
            >
              <div class="project-finance-summary__trend-val">
                {{ formattedChangeString(summaryData.summary.time_change) }}
              </div>
              <v-icon
                class="project-finance-summary__trend-ico"
                :class="{ 'project-finance-summary__trend-ico--decrease':
                  isNegative(summaryData.summary.time_change) }"
                medium
              >
                mdi-arrow-up-bold
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" lg="">
        <div class="project-finance-summary__card" >
          <div class="project-finance-summary__card-title">Price</div>
          <div class="project-finance-summary__card-data">
            <div class="project-finance-summary__value">
              {{ summaryData.summary.amount ? summaryData.summary.amount : '0' }} PLN
            </div>
            <div v-if="summaryData.summary.amount_change"
              class="project-finance-summary__trend"
              :class="{ 'project-finance-summary__trend--decrease':
                summaryData.summary.amount_change < 0 }"
            >
              <div class="project-finance-summary__trend-val">
                {{ formattedChangeString(summaryData.summary.amount_change) }}
              </div>
              <v-icon
                class="project-finance-summary__trend-ico"
                :class="{ 'project-finance-summary__trend-ico--decrease':
                  isNegative(summaryData.summary.time_change) }"
                medium
              >
                mdi-arrow-up-bold
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" lg="">
        <router-link
          class="project-finance-summary__link"
          v-ripple
          :to="routeLink"
        >
          <v-icon medium color="white">mdi-finance</v-icon>
          <span class="ml-2 mr-5">Finance</span>
          <img src="@/assets/img/arrow-right.svg" alt="Arrow right icon">
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    summaryData: {
      type: Object,
      required: true,
    },
    routeLink: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formattedChangeString(changeVal) {
      return changeVal < 0 ? `${changeVal}%` : `+ ${changeVal}%`;
    },

    isNegative(val) {
      return val < 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.project-finance-summary {
  margin-bottom: 16px;

  &__card {
    padding: 16px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
    height: 100%;
  }

  &__card-title {
    color: $main--headers;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  &__card-data {
    display: flex;
    justify-content: space-between;
  }

  &__value {
    color: $color--blue;
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
    flex: 1;
  }

  &__trend {
    display: flex;
    align-items: center;
    color: $color--green;
    margin-left: 16px;

    &--decrease {
      color: $color--red;
    }
  }

  &__trend-val {
    font-size: 12px;
    line-height: 14px;
    font-weight: 600;
    margin-right: 4px;
  }

  &__trend-ico {
    color: inherit;

    &--decrease {
      transform: rotate(180deg);
    }
  }

  &__link {
    padding: 16px;
    background: $color--blue;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    text-decoration: unset;
    font-weight: 500;
  }
}
</style>
